import { FlagSet as _FlagSet } from './src/feature-flag-client';

export type FlagSet = _FlagSet;
export { featureFlagClient } from './src/feature-flag-client';
export { useFeatureFlag } from './src/useFeatureFlag';
